export const booleanFalseIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#C94D42"><path d="M10 8.586l-7.07-7.07L1.515 2.93 8.586 10l-7.07 7.07 1.414 1.414 7.07-7.07 7.07 7.07 1.414-1.414-7.07-7.07 7.07-7.07-1.414-1.414L10 8.586z"/></svg>`,
  name: 'boolean-false',
};
